import  React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Section from '../shared/Section';
import Accordion from 'react-bootstrap/Accordion';
import Table from "react-bootstrap/Table";
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';





const Politic = (): React.JSX.Element => {
    const { t } = useTranslation();
   
    return <>
        <Section className="politic-section">
            <Row className='text-center'>
                <Col>
                    <h2 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.Title') === undefined ? "" : t('Pages.Cookies.Title') }
                    } />
                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.SubTitle') === undefined ? "" : t('Pages.Cookies.SubTitle') }
                    } />

                </Col>

            </Row>
        
                        {/*Introduction*/ }
        
            <Row >
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.IntroTitle') === undefined ? "" : t('Pages.Cookies.IntroTitle') }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.IntroText') === undefined ? "" : t('Pages.Cookies.IntroText') }
                    } />
                </Col>
            </Row>
       
                        {/*Quels sont les cookies*/}  
       

            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ExplicatioCookiesTitle') === undefined ? "" : t('Pages.Cookies.ExplicationCookiesTitle') }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ExplicationCookiesText') === undefined ? "" : t('Pages.Cookies.ExplicationCookiesText') }
                    } />
                </Col>
            </Row>

                         {/*Que sont les scripts ?*/ }


            <Row>
                <Col>
                    <h5 style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ScriptTitle') === undefined ? "" : t('Pages.Cookies.ScriptTitle') }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ScriptText') === undefined ? "" : t('Pages.Cookies.ScriptText') }
                    } />
                </Col>
            </Row>

      
                                            {/*Cookies*/}


            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.CookiesTitle2') === undefined ? "" : t('Pages.Cookies.CookiesTitle2') }
                    } />

                    <h6 style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.TechnicalCookiesTitle') === undefined ? "" : t('Pages.Cookies.TechnicalCookiesTitle')
                        }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.TechnicalCookiesText') === undefined ? "" : t('Pages.Cookies.TechnicalCookiesText') }
                    } />

                    <h6 style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.StatisticCookiesTitle') === undefined ? "" : t('Pages.Cookies.StatisticCookiesTitle')
                        }
                    } />

                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.StatisticCookiesText') === undefined ? "" : t('Pages.Cookies.StatisticCookiesText')
                        }
                    } />

                    <h6 style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.MarketingCookiesTitle') === undefined ? "" : t('Pages.Cookies.MarketingCookiesTitle')
                        }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        {
                            __html: t('Pages.Cookies.MarketingCookiesText') === undefined ? "" : t('Pages.Cookies.MarketingCookiesText')
                        }
                    } />
                      
                </Col>
            </Row>

                                        {/*Consentement*/ }
               

            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ConsentTitle') === undefined ? "" : t('Pages.Cookies.ConsentTitle') }
                    } />
                
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ConsentText') === undefined ? "" : t('Pages.Cookies.ConsentText') }
                    } />
                  
                  

                </Col>
            </Row>

                                    {/*Données Personnelles*/}

            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.DataUserTitle') === undefined ? "" : t('Pages.Cookies.DataUserTitle') }
                    } />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.DataUserText1') === undefined ? "" : t('Pages.Cookies.DataUserText1') }
                    } />

                        <ul>
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText2') === undefined ? "" : t('Pages.Cookies.DataUserText2') }
                        } />
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText3') === undefined ? "" : t('Pages.Cookies.DataUserText3') }
                        } />
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText4') === undefined ? "" : t('Pages.Cookies.DataUserText4') }
                        } />
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText5') === undefined ? "" : t('Pages.Cookies.DataUserText5') }
                        } />
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText6') === undefined ? "" : t('Pages.Cookies.DataUserText6') }
                        } />
                        <li dangerouslySetInnerHTML={
                            { __html: t('Pages.Cookies.DataUserText7') === undefined ? "" : t('Pages.Cookies.DataUserText7') }} />
                    </ul>
                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.DataUserText8') === undefined ? "" : t('Pages.Cookies.DataUserText8') }} />
                </Col>
            </Row>

      
                                    {/*Activer/Désactiver/Supprimer les cookies*/ }
       

            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.EnableDisableRemoveCookiesTitle') === undefined ? "" : t('Pages.Cookies.EnableDisableRemoveCookiesTitle') }} />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.EnableDisableRemoveCookiesText') === undefined ? "" : t('Pages.Cookies.EnableDisableRemoveCookiesText') }} />
                </Col>
            </Row>

        
                                            {/*Coordonnées*/ }
        

            <Row>
                <Col>
                    <h5 dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ContactDetailTitle') === undefined ? "" : t('Pages.Cookies.ContactDetailTitle') }} />
                    <p style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.ContactDetailText') === undefined ? "" : t('Pages.Cookies.ContactDetailText') }} />

                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.AddressDetailText') === undefined ? "" : t('Pages.Cookies.AddressDetailText') }} />

                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.WebSiteDetailText') === undefined ? "" : t('Pages.Cookies.WebSiteDetailText') }} />
                    <p dangerouslySetInnerHTML={
                        { __html: t('Pages.Cookies.EMailDetailText') === undefined ? "" : t('Pages.Cookies.EMailDetailText') }} />
                   
                    
                </Col>
            </Row>

        </Section>
    </>
}
export default Politic